import styles from './Header.module.scss';

import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import Logo from 'src/components/Logo';
import ButtonLink from 'src/components/ButtonLink';
import NavLink from 'src/components/NavLink';
import HamburgerIcon from 'src/components/HamburgerIcon';

const ListLink = (props) => {
  return (
    <li>
        <NavLink {...props} styleName='nav-link'>
            {props.children}
        </NavLink>
    </li>
  );
};

const DropdownItemLink = (props) => {
  return (
    <DropdownItem {...props}
                  tag={NavLink}
                  styleName='dropdown-link'>
        {props.children}
    </DropdownItem>
  );
};

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      scrolled: false
    };
    this.updateScroll = this.updateScroll.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }


  componentDidMount() {
    window.addEventListener('scroll', this.updateScroll);
    this.updateScroll();
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateScroll);
  };

  updateScroll() {
    const pageOffset = (window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop);

    this.setState({scrolled: pageOffset > 50});
  }

  /**
   * Sets the dropdown menu to the given open state.
   */
  toggleMenu(open) {
    const el = ReactDOM.findDOMNode(this.dropdownRef);
    if (el) {
      el.style.maxHeight = open ? el.scrollHeight + 'px' : '0';
    }

    this.setState({open});
  }

  /**
   * Closes the dropdown menu.
   */
  closeMenu() {
    this.toggleMenu(false);
  }

  render () {
    // Show the fixed wrapper background if either 1) the menu is open, or 2)
    // the element is scrolled.
    const shouldShowFixedWrapperBg = this.state.open || this.state.scrolled;
    return (
      <div styleName='header'>
          <div id='header-fixed-wrapper'
               styleName={classNames('fixed-wrapper', {'show-bg': shouldShowFixedWrapperBg})}>
              <Container styleName='container'>
                  <div styleName='logo-container'>
                      <Logo onClick={this.closeMenu} />
                  </div>
                  <HamburgerIcon
                      styleName='hamburger-icon'
                      open={this.state.open}
                      onClick={(e) => this.toggleMenu(!this.state.open)} />
                      <ul styleName='links-container navbar-horizontal'>
                          <li>
                              <UncontrolledDropdown>
                                  <DropdownToggle
                                      tag='a'
                                      href='#'
                                      onClick={(e) => e.preventDefault()}
                                      className='nav-link'
                                      styleName='nav-link'>
                                      Features
                                  </DropdownToggle>
                                  <DropdownMenu styleName='dropdown-menu'>
                                      <DropdownItemLink to='/features/dashboard'>
                                          Dashboard
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/reporting'>
                                          Reporting
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/auditing'>
                                          Auditing
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/optimization'>
                                          Optimization
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/carrier-agnostic'>
                                          Carrier agnostic
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/teams'>
                                          Teams
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/payments'>
                                          Payments
                                      </DropdownItemLink>
                                      <DropdownItemLink to='/features/api'>
                                          API
                                      </DropdownItemLink>
                                  </DropdownMenu>
                              </UncontrolledDropdown>
                          </li>
                          <ListLink to='/#savings'>Savings</ListLink>
                          <ListLink to='/#testimonials'>Testimonials</ListLink>
                          <li><div styleName='sep' /></li>
                          <li>
                              <a href='https://cloud.galleonlogistics.com'
                                 target='_blank'
                                 className='nav-link text-blue'
                                 styleName='nav-link'>
                                  Log in
                              </a>
                          </li>
                          <li>
                              <ButtonLink styleName='nav-link' to='/contact'>
                                  Sign up
                              </ButtonLink>
                          </li>
                      </ul>
              </Container>
              <div styleName='navmenu-dropdown'
                   ref={(ref) => {this.dropdownRef = ref;}}>
                  <Container styleName='content'>
                      <Row>
                          <Col xs='6'>
                              <strong styleName='heading'>Features</strong>
                              <ul styleName='links-container'>
                                  <ListLink to='/features/dashboard'
                                            onClick={this.closeMenu}>
                                      Dashboard
                                  </ListLink>
                                  <ListLink to='/features/reporting'
                                            onClick={this.closeMenu}>
                                      Reporting
                                  </ListLink>
                                  <ListLink to='/features/auditing'
                                            onClick={this.closeMenu}>
                                      Auditing
                                  </ListLink>
                                  <ListLink to='/features/optimization'
                                            onClick={this.closeMenu}>
                                      Optimization
                                  </ListLink>
                                  <ListLink to='/features/carrier-agnostic'
                                            onClick={this.closeMenu}>
                                      Carrier agnostic
                                  </ListLink>
                                  <ListLink to='/features/payments'
                                            onClick={this.closeMenu}>
                                      Payments
                                  </ListLink>
                                  <ListLink to='/features/teams'
                                            onClick={this.closeMenu}>
                                      Teams
                                  </ListLink>
                                  <ListLink to='/features/api'
                                            onClick={this.closeMenu}>
                                      API
                                  </ListLink>
                              </ul>
                          </Col>
                          <Col xs='6'>
                              <strong styleName='heading'>About</strong>
                              <ul styleName='links-container'>
                                  <ListLink to='/#savings'
                                            onClick={this.closeMenu}>
                                      Savings
                                  </ListLink>
                                  <ListLink to='/#testimonials'
                                            onClick={this.closeMenu}>
                                      Testimonials
                                  </ListLink>
                                  <ListLink to='/contact'
                                            onClick={this.closeMenu}>
                                      Contact
                                  </ListLink>
                                  <li>
                                      <a href='https://cloud.galleonlogistics.com'
                                         className='nav-link'
                                         styleName='nav-link'>
                                          Log in
                                      </a>
                                  </li>
                                  <ListLink to='/contact' onClick={this.closeMenu}>
                                      Sign up
                                  </ListLink>
                              </ul>
                          </Col>
                      </Row>
                  </Container>
              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Header.js